import React from 'react';

function PlusIcon({ width = 24, height = 24, ...rest }) {
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 24 24">
      <g>
        <circle cx="12" cy="12" r="12" />
        <path
          d="M 12 6 L 12 18 M 6 12 L 18 12"
          stroke="white"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export default PlusIcon;
